import { OnboardingUseCaseRelevancyData } from '../../../constants/recommendations/OnboardingUseCaseRelevancy';
import { HUBS, RELEVANCY_DATA_SOURCES } from '../../../types/relevancyData';
import { combineRelevancyData } from '../relevancyScoreUtils';
const HUB_INTEREST_TO_HUB = {
  marketing: HUBS.MARKETING,
  sales: HUBS.SALES,
  'customer-service': HUBS.SERVICE,
  cms: HUBS.CMS,
  operations: HUBS.OPS
};
const JOB_FIELD_TO_HUB = {
  sales: HUBS.SALES,
  marketing: HUBS.MARKETING,
  'services-support': HUBS.SERVICE,
  'administration-operations': HUBS.OPS
};
export const getRelevancyDataFromSurvey = surveyData => {
  const {
    user: userData
  } = surveyData;
  const {
    hubInterest,
    jobField,
    onboardingUseCases
  } = userData;
  const allSurveyResponsesRelevancyData = [];
  if (onboardingUseCases && onboardingUseCases.length > 0) {
    onboardingUseCases.forEach(useCase => {
      const relevancyData = OnboardingUseCaseRelevancyData[useCase];
      if (relevancyData) {
        allSurveyResponsesRelevancyData.push({
          hubs: relevancyData.hubs || [],
          dataTypes: relevancyData.dataTypes || []
        });
      }
    });
  }
  if (hubInterest in HUB_INTEREST_TO_HUB) {
    allSurveyResponsesRelevancyData.push({
      hubs: [HUB_INTEREST_TO_HUB[hubInterest]]
    });
  }
  if (jobField in JOB_FIELD_TO_HUB) {
    const hub = JOB_FIELD_TO_HUB[jobField];
    allSurveyResponsesRelevancyData.push({
      hubs: [hub]
    });
  }
  const {
    dataTypes,
    hubs
  } = combineRelevancyData(allSurveyResponsesRelevancyData);
  if (!(dataTypes !== null && dataTypes !== void 0 && dataTypes.length) && !(hubs !== null && hubs !== void 0 && hubs.length)) {
    return null;
  }
  return {
    dataSource: RELEVANCY_DATA_SOURCES.SIGNUP_SURVEY,
    dataTypes,
    hubs
  };
};